/**
 * ============================================================================
 * DISPUTE DETAIL PAGE - 100% Ready
 * ============================================================================
 * 
 * Page for viewing and managing a single dispute
 */

import React from 'react';
import { UserDashboardLayout } from '../components/user';
import ResolutionCenter from '../components/dispute/ResolutionCenter';

/**
 * Dispute Detail Page
 * @returns {JSX.Element}
 */
const DisputeDetail = () => {
  return (
    <UserDashboardLayout>
      <ResolutionCenter />
    </UserDashboardLayout>
  );
};

export default DisputeDetail;
